import React from 'react'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { Card } from '../../../components/Card'
import { Button } from 'src/components/Button'
import Banner  from '../../../assets/images/Banner.png'
import curveArrow from '../../../assets/icons/curveArrow.png'
import styles from './Step1.module.scss'

interface IProps {
  nextStep: () => void
}

export const Step1 = ({ nextStep }: IProps) => {
  return (
    <>
      <img className={styles.MobileBanner} src={Banner} alt="models" />
      <div className={styles.Wrapper}>
        <Card title={"UnionClothes.stage1.title"} description={"UnionClothes.stage1.description"} bigTitle>
          <div className={styles.Cards}>
            <div className={styles.Card}>
              <span className={`${styles.CardTitle} ${styles.Active}`}>1.</span>
              <div className={styles.CardDescription}>
                <FormattedMessage id= "UnionClothes.stage1.step1"/>
              </div>
            </div>
            <div className={styles.Card}>
              <span className={`${styles.CardTitle}`}>2.</span>
              <div className={styles.CardDescription}>
                <FormattedMessage id="UnionClothes.stage1.step2" />
              </div>
            </div>
            <div className={styles.Card}>
              <span className={`${styles.CardTitle}`}>3.</span>
              <div className={styles.CardDescription}>
                <FormattedMessage id="UnionClothes.stage1.step3" />
              </div>
            </div>
          </div>
          <div className={styles.ButtonWrapper}>
            <img className={styles.Arrow} src={curveArrow} alt={'arrow'}/>
              <Button
                  onClick={nextStep}
                  buttonColor
                  buttonDescription={"UnionClothes.stage1.button"}
              />
          </div>
        </Card>
      </div>
    </>
  )
}
